const Bar = ({ className }) => (
  <div className={`bg-gray-200 rounded animate-pulse ${className}`} />
)

const Pills = ({ count, tone }) => (
  <div className="flex flex-wrap gap-1.5">
    {Array.from({ length: count }, (_, index) => (
      <div
        key={index}
        className={`h-5 w-20 rounded-full animate-pulse ${tone}`}
      />
    ))}
  </div>
)

const Block = ({ children }) => (
  <div className="bg-gray-50 rounded-xl p-4 flex flex-col gap-2">
    <Bar className="h-3 w-24" />
    {children}
  </div>
)

// Mirrors the loaded pane's two-column grid, so nothing jumps when the detail
// arrives.
const DetailSkeleton = () => (
  <div className="p-5 flex flex-col gap-4">
    <Bar className="h-5 w-72" />

    <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_minmax(0,1.1fr)] gap-4">
      <div className="flex flex-col gap-3 min-w-0">
        <Block>
          <Pills count={4} tone="bg-indigo-100" />
        </Block>
        <Block>
          <Pills count={3} tone="bg-amber-100" />
        </Block>
        <Block>
          <Pills count={2} tone="bg-green-100" />
        </Block>
      </div>

      <div className="flex flex-col gap-3 min-w-0">
        <Block>
          {[1, 2, 3].map((row) => (
            <div key={row} className="flex flex-col gap-1.5 py-1">
              <Bar className="h-3 w-40" />
              <Bar className="h-[3px] w-full" />
            </div>
          ))}
        </Block>
        <Block>
          <div className="grid grid-cols-3 gap-2">
            {[1, 2, 3].map((tile) => (
              <Bar key={tile} className="h-12" />
            ))}
          </div>
        </Block>
      </div>
    </div>

    <div className="bg-gray-50 rounded-xl p-4">
      <Bar className="h-3 w-32 mb-3" />
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-6 gap-y-2.5">
        {[1, 2, 3, 4].map((row) => (
          <Bar key={row} className="h-4" />
        ))}
      </div>
    </div>
  </div>
)

export default DetailSkeleton
